import { initServices } from './serviceConfig'

let _svc
let _that

export default {
  Init: async (that) => {
    _that = that

    _svc = await initServices()

    _svc.interceptors.response.use(
      response => response,
      error => {
        _that.ErrorMixin_HandleError(error)
      }
    )
  },
  GetPosten: () => {
    try {
      return _svc.get('Postcode')
    } catch {
      return null
    }
  }
}
